import React, {useEffect, useState} from 'react';
import AppContainer from "../../components/AppContainer";
import OpsText from "../../ops-library/ops-text";
import ArticlePreview from "../../components/app/ArticlePreview";
import ReactPaginate from "react-paginate";
import {MdArrowBackIosNew} from "react-icons/md";
import axios from "axios";
import opsToast from "../../ops-library/ops-toast";
import {LoadingSpinner} from "../../components/LoadingSpinner";
import ConcertPreview from "../../components/app/ConcertPreview";
import {Modal} from "react-bootstrap";
import OpsInput from "../../ops-library/ops-input";
import OpsBtn from "../../ops-library/ops-btn";
import {BackgroundImages} from "../../components/AuthBackground";


const Concerts = () => {

    const [concerts, setConcerts] = useState(null);
    const [modalConcertShown, setModalConcertShown] = useState(false);
    const [modalDataConcert, setModalDataConcert] = useState({posterImg: "", ticketsUrl: "", price: null});


    useEffect(() => {
        getAllPublishedConcerts();
    }, []);

    function getAllPublishedConcerts() {
        const configuration = {
            method: "get",
            url: `${process.env.REACT_APP_API_BASE_URL}/concerts/published`,
        };

        axios(configuration)
            .then((result) => {
                const currentYear = new Date().getFullYear();
                let temp = result.data.content.reduce((acc, concert) => {
                    const concertDate = new Date(concert.dateTime);
                    const month = concertDate.toLocaleString('sk-SK', {month: 'long'}).toUpperCase(); // Slovenský názov mesiaca veľkými písmenami
                    const year = concertDate.getFullYear();
                    const monthYear = year !== currentYear ? `${month} ${year}` : month;

                    if (!acc[monthYear]) {
                        acc[monthYear] = [];
                    }

                    acc[monthYear].push(concert);

                    return acc;
                }, {})

                setConcerts(temp)
            })
            .catch((error) => {
                console.log(error)
                opsToast(error.response?.data?.message, "error", "colored", true, "top-center");
            });
    }

    function handleOpenModalConcert(data) {
        if (data) {
            setModalConcertShown(true);
            setModalDataConcert(data);
        }
    }

    function handleModalsClose() {
        setModalConcertShown(false);
        setModalDataConcert({posterImg: "", ticketsUrl: "", price: null})
    }

    const ModalConcert = ({show = false, onHide}) => {

        return (
            <Modal show={show} onHide={onHide} dialogClassName="custom-modal-container">
                <Modal.Header closeButton closeVariant="white" className="modal-background-color"/>

                <Modal.Body className="modal-background-color fa-flex-col align-items-center">
                    <div className="custom-modal-content">

                        {modalDataConcert?.posterImg &&
                            <div className="concert-poster mt-5">
                                <img src={`${process.env.REACT_APP_API_BASE_URL}/${modalDataConcert?.posterImg}`}
                                     className="w-100 h-100 object-fit-cover" alt=""/>
                            </div>
                        }


                        {modalDataConcert?.ticketsUrl.length > 0 &&
                            <div className="desktop-row-phone-col mt-5 mb-3 w-100 justify-content-center">
                                <OpsBtn
                                    text="Kúpiť lístky"
                                    variant="primary"
                                    size="md mt-2"
                                    action={() => window.open(modalDataConcert?.ticketsUrl, "_blank", "noreferrer")}
                                />
                            </div>
                        }
                    </div>
                </Modal.Body>
            </Modal>
        )
    }


    return (
        <AppContainer
            showSlides={false}
            content={
                concerts !== null ?
                    <div
                        className="window-content-container fa-flex-col align-items-center justify-content-center py-5">
                        <ModalConcert show={modalConcertShown} onHide={() => handleModalsClose()}/>
                        <BackgroundImages auth={false}/>
                        <div
                            className="fa-flex-col desktop-30-phone-100 justify-content-center align-items-center position-relative gap-4 mt-5 pt-5">
                            {Object.entries(concerts).map(([month, concertsInMonth]) => (
                                <div key={month} className="fa-w-100">
                                    <OpsText
                                        type="title7 px-1"
                                        weight={800}
                                        color="color-1"
                                        alignment="left"
                                        content={month}
                                    />
                                    {concertsInMonth.map((item, index) => (
                                        <ConcertPreview
                                            concert={item}
                                            key={index}
                                            className="prew-concert-container mb-2"
                                            action={() => (item.posterImg || item.ticketsUrl.length > 0) && handleOpenModalConcert({
                                                posterImg: item.posterImg,
                                                ticketsUrl: item.ticketsUrl,
                                                price: item.price
                                            })}
                                        />
                                    ))}
                                </div>
                            ))}
                        </div>
                    </div>
                    :
                    <div className="window-content-container pt-2 pb-5">
                        <LoadingSpinner/>
                    </div>
            }
        />
    );
};

export default Concerts;